module.exports = __webpack_public_path__ + "static/media/assorted-vegetable.38c946e8.jpg";